import { downloadWarehouseCSV } from "@/helpers/apis";
import { DownloadTable } from "@/components/downloadTable";
import { useWarehouseFilters } from "../hooks/useWarehouseFilters";

interface WarehouseDownloadProps {
  disabled?: boolean;
}

const WarehouseDownload = ({ disabled }: WarehouseDownloadProps) => {
  const { filterParams } = useWarehouseFilters();

  const handleWarehouseDataDownload = async () => {
    await downloadWarehouseCSV(filterParams);
  };

  return (
    <DownloadTable
      handleDownload={handleWarehouseDataDownload}
      buttonProps={{ disabled, variant: "outline" }}
    />
  );
};

export default WarehouseDownload;
